export type OnSaveClickEvent = (input: string) => Promise<boolean>;

export class PromptDialogModel {

    /**
     * @param onSaveClick Save click event. If this function returns true, dialog will be closed. Loading
     * icon will be diaplayed while this function is being executed
     * @param isInputRequired If true, an input is required
     * @param initialText Initial text to display
     */
    constructor(
        public title: string,
        public onSaveClick: OnSaveClickEvent,
        public isInputRequired = true,
        public initialText = "",
    ) { }

}